import React from 'react';
import Pricing from './Pricing';

const InternachiPricing: React.FC = () => (
  <Pricing
    discountFactor={0.9}
    discountMessage="Exclusive 10% discount for InterNACHI® members applied!"
  />
);

export default InternachiPricing;
